import type { Prop, PropAttributeTable } from "building-types/props/propTypes";
import { GLTF_ASSET_SCALE } from "common/constants/assetConstants";
import type { MergedPropLibrary } from "doc/propTools";

export async function propBBAdjustments(
  propCatalog: PropAttributeTable,
  propMatch: Prop,
  mergedPropLibrary: MergedPropLibrary,
): Promise<{ xAdj: number; yAdj: number }> {
  const propAssetId = propCatalog[propMatch.src]?.propAssetId;
  if (propAssetId === undefined) {
    return { xAdj: 0, yAdj: 0 };
  }
  const propSrc = await mergedPropLibrary.get(propAssetId);
  if (!propSrc) {
    return { xAdj: 0, yAdj: 0 };
  }

  const {
    boundingBox: { minX, maxX, minY, maxY },
  } = propSrc;
  const xAdj = (minX + (maxX - minX) / 2) * GLTF_ASSET_SCALE;
  const yAdj = -(minY + (maxY - minY) / 2) * GLTF_ASSET_SCALE;
  return { xAdj: xAdj * propMatch.scaleX, yAdj: yAdj * propMatch.scaleY };
}
